<!-- https://8es9hr.axshare.com/#g=1&p=%E6%AA%A2%E8%A6%96%E5%8A%A0%E9%80%80%E4%BF%9D%E7%94%B3%E8%AB%8B%E5%90%8D%E5%86%8A -->
<!-- 儲互社加退保申請名冊管理
     儲互社加保申請通過名單管理
     儲互社加保申請不通過名單管理
     儲互社加保申請補件名單管理
     儲互社退保申請名冊管理  -->
<template>
	<div class="row">
		<div class="col-12">
			<div class="col-block">
				<div class="block-header has-border">
					<h3>
						<strong>
							{{
								$route.query.type == "quit"
									? "退保作業"
									: $route.query.type == "modify"
									? "資料變更作業"
									: "加保作業"
							}}
						</strong>
						申請序號 : {{ recordToEdit.code }}
					</h3>
				</div>
				<div class="block-content">
					<el-tabs type="border-card">
						<el-tab-pane label="基本資料">
							<el-form label-position="top">
								<el-form-item
									label="申請方案"
									v-if="
										type == 'add' &&
										$route.query.type !== 'modify'
									"
								>
									<div v-if="$route.query.type !== 'quit'">
										<el-select
											v-model="
												recordToEdit.insEmployeeYearId
											"
											placeholder="請選擇"
										>
											<el-option
												v-for="(
													item, index
												) in yearData"
												:key="index"
												:label="item.year"
												:value="item.id"
											></el-option>
										</el-select>
										<el-select
											v-model="
												recordToEdit.insEmployeeSubId
											"
											placeholder="請選擇"
											class="ml10"
										>
											<el-option
												v-for="(
													item, index
												) in selectProject"
												:key="index"
												:label="item.name"
												:value="item.id"
											></el-option>
										</el-select>
									</div>
									<div v-if="$route.query.type == 'quit'">
										<el-select
											v-model="
												recordToEdit.insEmployeeYearId
											"
											placeholder="請選擇"
											:disabled="true"
										>
											<el-option
												v-for="(
													item, index
												) in yearData"
												:key="index"
												:label="item.year"
												:value="item.id"
											></el-option>
										</el-select>
										<el-select
											v-model="
												recordToEdit.insEmployeeSubId
											"
											placeholder="請選擇"
											class="ml10"
											:disabled="true"
										>
											<el-option
												v-for="(
													item, index
												) in selectProject"
												:key="index"
												:label="item.name"
												:value="item.id"
											></el-option>
										</el-select>
									</div>

									<h3 v-if="$route.query.type !== 'modify'">
										<b>互助費 : {{ subFee }}</b>
									</h3>
								</el-form-item>
								<el-form-item
									label="選擇幹部種類"
									v-if="
										type == 'add' &&
										$route.query.type !== 'modify'
									"
								>
									<el-select
										v-model="recordToEdit.cadreTitle"
										class="mr10"
										placeholder="職稱"
									>
										<el-option
											v-for="(item, index) in cadreList"
											:key="index"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item
									label="輸入申請人證件號"
									v-if="
										id == 'new' &&
										$route.query.type == 'quit'
									"
								>
									<el-input
										v-model="account"
										placeholder="請輸入內容"
										style="width: 200px"
										class="mb10"
									></el-input>
									<el-button
										type="primary"
										plain
										class="ml10"
										@click="schMember(account)"
										>確認</el-button
									>
									<table
										class="table table-bordered mb-0"
										v-if="formshow"
									>
										<tbody>
											<tr>
												<td>是否為社員</td>
												<td
													v-if="
														recordToEdit.isMember ==
														1
													"
												>
													{{
														"是" +
														" " +
														recordToEdit.account
													}}
												</td>
												<td v-else>否</td>
											</tr>
											<tr>
												<td>姓名</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.name
														"
													></el-input>
												</td>
											</tr>
											<tr>
												<td>性別</td>
												<td>
													<el-radio
														v-model="
															recordToEdit.sex
														"
														:label="2"
														>女性</el-radio
													>
													<el-radio
														v-model="
															recordToEdit.sex
														"
														:label="1"
														>男性</el-radio
													>
												</td>
											</tr>
											<tr>
												<td>
													證件號碼 (身分證/居留證等)
												</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.idNumber
														"
													></el-input>
													<!-- <el-button type="primary"
                                                       plain
                                                       size="small"
                                                    @click="getMemberData">查詢</el-button>-->
												</td>
											</tr>
											<tr>
												<td>出生年月</td>
												<td>
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																birthday1
																birthday
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td>職稱</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.jobTitle
														"
													></el-input>
												</td>
											</tr>
											<tr>
												<td>任期</td>
												<td>
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																employeeStartDate1
																employeeStartDate
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
													~
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																employeeEndDate1
																employeeEndDate
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
												</td>
											</tr>
											<tr v-if="false">
												<td>申請變更項目</td>
												<td>
													<el-checkbox-group
														v-model="
															recordToEdit.applyType
														"
													>
														<el-checkbox
															v-for="item in applyType"
															:label="item.label"
															:key="item.value"
															>{{
																item.label
															}}</el-checkbox
														>
													</el-checkbox-group>
												</td>
											</tr>
										</tbody>
									</table>
									<div>
										<div
											style="
												font-size: 18px;
												font-weight: bold;
											"
											v-if="formshow"
										>
											申請方案
										</div>
										<span>{{ subName }}</span>
										<br />
										已繳互助費 :
										{{ payment.payAmount || 0 }}
										<br />
										應退互助費 :
										{{ payment.backAmount || 0 }}
									</div>
								</el-form-item>
								<el-form-item
									label="輸入申請人證件號"
									v-if="
										id == 'new' &&
										$route.query.type == 'modify'
									"
								>
									<el-input
										v-model="account"
										placeholder="請輸入內容"
										style="width: 200px"
										class="mb10"
									></el-input>
									<el-button
										type="primary"
										plain
										class="ml10"
										@click="schMember(account)"
										>確認</el-button
									>
									<table
										class="table table-bordered mb-0"
										v-if="formshow"
									>
										<tbody>
											<tr>
												<td>是否為社員</td>
												<td
													v-if="
														recordToEdit.isMember ==
														1
													"
												>
													{{
														"是" +
														" " +
														recordToEdit.account
													}}
												</td>
												<td v-else>否</td>
											</tr>
											<tr>
												<td>姓名</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.name
														"
													></el-input>
												</td>
											</tr>
											<tr>
												<td>性別</td>
												<td>
													<el-radio
														v-model="
															recordToEdit.sex
														"
														:label="2"
														>女性</el-radio
													>
													<el-radio
														v-model="
															recordToEdit.sex
														"
														:label="1"
														>男性</el-radio
													>
												</td>
											</tr>
											<tr>
												<td>
													證件號碼 (身分證/居留證等)
												</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.idNumber
														"
													></el-input>
													<!-- <el-button type="primary"
                                                       plain
                                                       size="small"
                                                    @click="getMemberData">查詢</el-button>-->
												</td>
											</tr>
											<tr>
												<td>出生年月</td>
												<td>
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																birthday1
																birthday
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td>職稱</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.jobTitle
														"
													></el-input>
												</td>
											</tr>
											<tr>
												<td>任期</td>
												<td class="mt10">
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																employeeStartDate1
																employeeStartDate
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
													~
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																employeeEndDate1
																employeeEndDate
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
												</td>
											</tr>
											<tr v-if="false">
												<td>申請變更項目</td>
												<td>
													<el-checkbox-group
														v-model="
															recordToEdit.applyType
														"
													>
														<el-checkbox
															v-for="item in applyType"
															:label="item.label"
															:key="item.value"
															>{{
																item.label
															}}</el-checkbox
														>
													</el-checkbox-group>
												</td>
											</tr>
										</tbody>
									</table>
								</el-form-item>
								<el-form-item
									label="申請人資料"
									v-if="id !== 'new'"
								>
									<!-- <el-button plain>開啟申請人個人資訊</el-button> -->
									<span
										style="color: red"
										class="ml10"
										v-if="member.applyTypeStr"
										>{{ member.applyTypeStr }}</span
									>
									<table
										class="
											table table-bordered
											mb-0
											mt10
											info
										"
									>
										<tbody>
											<tr>
												<td>是否為社員</td>
												<td
													v-if="
														recordToEdit.isMember ==
														1
													"
												>
													{{ "是" }}
													{{
														recordToEdit.memberAccount
													}}
												</td>
												<td v-else>否</td>
											</tr>
											<tr>
												<td>社號</td>
												<td>
													{{ recordToEdit.coopCode }}
												</td>
											</tr>
											<tr>
												<td>姓名</td>
												<td>{{ recordToEdit.name }}</td>
											</tr>
											<tr>
												<td>性別</td>
												<td>
													{{
														recordToEdit.sex
															| sexfilter
													}}
												</td>
											</tr>
											<tr>
												<td>
													證件號碼 (身分證/居留證等)
												</td>
												<td>
													{{ recordToEdit.idNumber }}
												</td>
											</tr>
											<tr>
												<td>出生年月</td>
												<td>
													{{
														$transferDate(
															recordToEdit.birthday
														)
													}}
												</td>
											</tr>
											<tr>
												<td>職稱</td>
												<td>
													{{ recordToEdit.title }}
												</td>
											</tr>
											<tr>
												<td>任期</td>
												<td>
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																employeeStartDate1
																employeeStartDate
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
													~
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																employeeEndDate1
																employeeEndDate
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td>身份別</td>
												<td></td>
											</tr>
										</tbody>
									</table>
								</el-form-item>
								<el-form-item
									label="確認申請人資料"
									v-if="
										id == 'new' &&
										$route.query.type !== 'quit' &&
										$route.query.type !== 'modify'
									"
								>
									<span style="color: red">新加保</span>
									<table class="table table-bordered mb-0">
										<tbody>
											<tr>
												<td>是否為社員</td>
												<td
													v-if="
														recordToEdit.isMember ==
														1
													"
												>
													{{ "是" }}
													{{
														recordToEdit.memberAccount
													}}
												</td>
												<td v-else>否</td>
											</tr>
											<tr>
												<td>姓名</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.name
														"
													></el-input>
												</td>
											</tr>
											<tr>
												<td>性別</td>
												<td>
													<el-radio
														v-model="
															recordToEdit.sex
														"
														:label="2"
														>女性</el-radio
													>
													<el-radio
														v-model="
															recordToEdit.sex
														"
														:label="1"
														>男性</el-radio
													>
												</td>
											</tr>
											<tr>
												<td>
													證件號碼 (身分證/居留證等)
												</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.idNumber
														"
													></el-input>
													<!-- <el-button type="primary"
                                                               plain
                                                               size="small"
                                                    @click="getMemberData">查詢</el-button>-->
												</td>
											</tr>
											<tr>
												<td>出生年月</td>
												<td>
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																birthday1
																birthday
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td>職稱</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.jobTitle
														"
													></el-input>
												</td>
											</tr>
											<tr>
												<td>任期</td>
												<td>
													<div class="date">
														<input
															type="text"
															class="
																min_go_date
																employeeStartDate1
																employeeStartDate
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
													~
													<div class="date mt10">
														<input
															type="text"
															class="
																min_go_date
																employeeEndDate1
																employeeEndDate
															"
															placeholder="選擇日期"
															:disabled="
																id !== 'new'
																	? true
																	: false
															"
														/>
														<span
															class="
																el-input__prefix
															"
														>
															<i
																class="
																	el-icon-date
																"
															></i>
														</span>
													</div>
												</td>
											</tr>
											<tr v-if="false">
												<td>申請變更項目</td>
												<td>
													<el-checkbox-group
														v-model="
															recordToEdit.applyType
														"
													>
														<el-checkbox
															v-for="item in applyType"
															:label="item.label"
															:key="item.value"
															>{{
																item.label
															}}</el-checkbox
														>
													</el-checkbox-group>
												</td>
											</tr>
										</tbody>
									</table>
								</el-form-item>
								<!-- <el-form-item label="申請方案"
                                              v-if="type == 'cadre'">
                                    <el-select v-model="value"
                                               placeholder="請選擇">
                                        <el-option v-for="item in options"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value"></el-option>
                                    </el-select>
                                    <el-select v-model="value"
                                               placeholder="請選擇"
                                               class="ml10">
                                        <el-option v-for="item in options"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value"></el-option>
                                    </el-select>
                                    <br />互助費 : 1,000
                                </el-form-item>-->
								<!-- <el-form-item label="受益人分配方式"
                                              v-if="$route.query.type != 'quit' && id!=='new'">
                                    <el-radio-group v-model="recordToEdit.bnfType"
                                                    :disabled="true">
                                        <el-radio v-for="(item,index) in bnf"
                                                  :key="index"
                                                  :label="item.value">{{item.label}}</el-radio>
                                    </el-radio-group>
                                </el-form-item>-->
								<!-- <el-form-item label="受益人分配方式"
                                              v-if="$route.query.type=='quit'">
                                    <el-radio-group v-model="recordToEdit.bnfType">
                                        <el-radio v-for="(item,index) in bnf"
                                                  :key="index"
                                                  :label="item.value">{{item.label}}</el-radio>
                                        <el-radio :label="0">
                                            平均分配
                                        </el-radio>
                                        <el-radio :label="1">
                                            依照順序
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>-->
								<!-- append -->
								<el-form-item
									label="受益人分配方式"
									v-if="
										id == 'new' &&
										$route.query.type !== 'quit'
									"
								>
									<el-radio-group
										v-model="recordToEdit.bnfType"
									>
										<el-radio
											v-for="(item, index) in bnf"
											:key="index"
											:label="item.value"
											>{{ item.label }}</el-radio
										>
									</el-radio-group>
								</el-form-item>
								<!-- <el-form-item
                                    label="獎勵或補助/其他扣除金額"
                                    v-if="
                                        id == 'new' &&
                                            $route.query.type !== 'quit' &&
                                            $route.query.type !== 'modify'
                                    "
                                >
                                    <el-input
                                        v-model="recordToEdit.subsidyAmount"
                                        placeholder="請輸入金額"
                                        style="width: 220px;"
                                    >
                                        <template slot="prepend">NT $</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item
                                    label="相關傳票"
                                    v-if="
                                        id == 'new' &&
                                            $route.query.type !== 'quit' &&
                                            $route.query.type !== 'modify'
                                    "
                                >
                                    <div class="date">
                                        <input
                                            type="text"
                                            class="min_go_date subsidyVoucherDate1 subsidyVoucherDate"
                                            placeholder="選擇日期"
                                            :disabled="id!=='new' ? true : false"
                                        />
                                        <span class="el-input__prefix">
                                            <i class="el-icon-date"></i>
                                        </span>
                                    </div>
                                    <el-input
                                        v-model="
                                            recordToEdit.subsidyVoucherCode
                                        "
                                        class="ml10"
                                        placeholder="請輸入傳票號碼"
                                        style="width: 200px;"
                                    ></el-input>
                                </el-form-item>-->
								<!-- append -->
								<!-- <el-form-item
                                    label="獎勵或補助/其他扣除金額"
                                    v-if="
                                        $route.query.type != 'quit' &&
                                            id !== 'new'
                                    "
                                >
                                    <el-input
                                        :disabled="true"
                                        v-model="recordToEdit.subsidyAmount"
                                        placeholder="請輸入金額"
                                        style="width: 220px;"
                                    >
                                        <template slot="prepend">NT $</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item
                                    label="相關傳票"
                                    v-if="
                                        $route.query.type != 'quit' &&
                                            id !== 'new'
                                    "
                                >
                                    <div class="date">
                                        <input
                                            type="text"
                                            class="min_go_date subsidyVoucherDate1 subsidyVoucherDate"
                                            placeholder="選擇日期"
                                            :disabled="id!=='new' ? true : false"
                                        />
                                        <span class="el-input__prefix">
                                            <i class="el-icon-date"></i>
                                        </span>
                                    </div>
                                    <el-input
                                        v-model="
                                            recordToEdit.subsidyVoucherCode
                                        "
                                        class="ml10"
                                        placeholder="請輸入傳票號碼"
                                        style="width: 200px;"
                                        :disabled="true"
                                    ></el-input>
                                </el-form-item>-->
								<el-form-item
									label="申請日期"
									v-if="id !== 'new'"
								>
									{{
										$transferDate(recordToEdit.sendGenDate)
									}}
								</el-form-item>
								<!--{{recordToEdit.sendGenDate.split(' ')[0]}} -->
								<el-form-item
									label="協會送件日期"
									v-show="id !== 'new'"
								>
									<div class="date">
										<input
											type="text"
											class="
												min_go_date
												genSendDate1
												genSendDate
											"
											placeholder="選擇日期"
										/>
										<span class="el-input__prefix">
											<i class="el-icon-date"></i>
										</span>
									</div>
								</el-form-item>
								<el-form-item
									label="協會送件郵局存根條碼"
									v-if="id !== 'new'"
								>
									<el-input
										v-model="recordToEdit.genSendCode"
										style="width: 220px"
									></el-input>
								</el-form-item>

								<el-form-item label="保單號碼">
									<el-input
										v-model="recordToEdit.policyNumber"
										style="width: 220px"
									></el-input>
								</el-form-item>

								<el-form-item label="投保編號">
									<el-input
										v-model="recordToEdit.insuranceCode"
										style="width: 220px"
									></el-input>
								</el-form-item>

								<el-form-item
									:label="underwriteStatusLabel"
									v-if="id !== 'new'"
								>
									<el-radio-group
										v-model="recordToEdit.underwriteStatus"
									>
										<el-radio
											v-for="(
												underwrite, index
											) in underwriteStatus"
											:key="index"
											:label="underwrite.value"
											>{{ underwrite.label }}</el-radio
										>
									</el-radio-group>
								</el-form-item>
								<!--underwriteStatus == 通過(1)-->
								<el-form-item
									label="保險卡狀態"
									v-if="
										recordToEdit.underwriteStatus == 1 &&
										id !== 'new'
									"
								>
									<el-radio-group
										v-model="recordToEdit.insCardSendStatus"
									>
										<el-radio
											v-for="(
												cardSend, index
											) in cardSendStatus"
											:key="index"
											:label="cardSend.value"
											:disabled="true"
											>{{ cardSend.label }}</el-radio
										>
									</el-radio-group>
								</el-form-item>
								<!--underwriteStatus == 不通過(2)-->
								<!-- <el-form-item label="退費狀態"
                                              v-if="recordToEdit.underwriteStatus == 2 ||recordToEdit.underwriteStatus == 3">
                                    <el-radio-group v-model="recordToEdit.refoundStatus">
                                        <el-radio v-for="(refound,index) in refoundStatus"
                                                  :key="index"
                                                  :label="refound.value">{{refound.label}}</el-radio>
                                    </el-radio-group>
                                </el-form-item>-->
								<el-form-item
									label="保險卡寄送日期"
									v-show="recordToEdit.underwriteStatus == 1"
								>
									<div class="date">
										<input
											type="text"
											class="
												min_go_date
												insCardSendDate1
												insCardSendDate
											"
											placeholder="選擇日期"
										/>
										<span class="el-input__prefix">
											<i class="el-icon-date"></i>
										</span>
									</div>
								</el-form-item>

								<el-form-item
									label="保險公司實收保費"
									v-show="recordToEdit.underwriteStatus == 1"
								>
									<el-input
										v-model="recordToEdit.realPremium"
										v-on:input="
											resetAmount(
												recordToEdit.realPremium,
												'realPremium'
											)
										"
										class="ml10"
										style="width: 200px"
									></el-input>
								</el-form-item>

								<el-form-item
									label="社應繳協會"
									v-show="recordToEdit.underwriteStatus == 1"
								>
									<el-input
										v-model="recordToEdit.insCoopToAssn"
										v-on:input="
											resetAmount(
												recordToEdit.insCoopToAssn,
												'insCoopToAssn'
											)
										"
										class="ml10"
										style="width: 200px"
									></el-input>
								</el-form-item>

								<el-form-item
									label="生效日期"
									v-show="
										id !== 'new' &&
										recordToEdit.underwriteStatus == 1
									"
								>
									<div class="date">
										<input
											type="text"
											class="
												min_go_date
												insEffectiveDate1
												insEffectiveDate
											"
											placeholder="選擇日期"
										/>
										<span class="el-input__prefix">
											<i class="el-icon-date"></i>
										</span>
									</div>
								</el-form-item>

								<el-form-item
									label="補件狀態"
									v-if="
										$route.query.type != 'quit' &&
										id !== 'new'
									"
								>
									<el-radio-group
										v-model="recordToEdit.needAddDoc"
									>
										<el-radio
											v-for="(
												addDoc, index
											) in addDocStatus"
											:key="index"
											:label="addDoc.value"
											>{{ addDoc.label }}</el-radio
										>
									</el-radio-group>
								</el-form-item>

								<el-form-item>
									<el-button
										type="primary"
										@click="openDialog"
										plain
										>建立補件通知</el-button
									>
								</el-form-item>

								<!-- 補件通知Dialog -->
								<el-dialog
									title="補件通知"
									:visible.sync="dialogAddDoc"
									:modal-append-to-body="false"
									:append-to-body="true"
								>
									<el-form ref="ruleForm">
										<el-form-item>
											<el-input
												v-model="noticeData"
												class="mt10"
												type="textarea"
												:rows="4"
											></el-input>
											<el-button
												type="primary"
												class="mt10"
												@click="sendAddDocNotice"
												plain
												>發送補件通知</el-button
											>
										</el-form-item>
										<el-form-item label="歷史紀錄">
											<workbench
												api="InsEmployeeMemberApply"
												:query="queryHistory"
												:columns="columns2"
												:toolbar="toolbarHistory"
												ref="queryHistory"
											></workbench>
										</el-form-item>
									</el-form>
								</el-dialog>
								<el-form-item
									label="退費狀態"
									v-if="
										recordToEdit.underwriteStatus == 2 ||
										(recordToEdit.underwriteStatus == 3 &&
											$route.query.type !== 'modify')
									"
								>
									<el-radio-group
										v-model="recordToEdit.refoundStatus"
									>
										<el-radio
											v-for="(
												refound, index
											) in refoundStatus"
											:key="index"
											:label="refound.value"
											>{{ refound.label }}</el-radio
										>
									</el-radio-group>
								</el-form-item>
								<el-form-item
									label="退費金額"
									v-if="recordToEdit.refoundStatus === 1"
								>
									<el-input
										v-model="recordToEdit.realBackAmount"
										class="ml10"
										placeholder="請輸入退費金額"
										style="width: 200px"
									></el-input>
								</el-form-item>
								<!-- <el-form-item label="協會退費狀態"
                                              v-if="$route.query.type == 'quit'">
                                    <el-radio-group v-model="radio">
                                        <el-radio class="flex"
                                                  :label="3">處理中</el-radio>
                                        <el-radio class="flex"
                                                  :label="6">
                                            通過
                                            <br />
                                            <el-checkbox class="ml10"
                                                         v-model="checked">已退費</el-checkbox>
                                        </el-radio>
                                        <el-radio class="flex"
                                                  :label="6">不通過</el-radio>
                                    </el-radio-group>
                                </el-form-item>-->
							</el-form>
							<el-button
								type="primary"
								@click="append"
								v-if="id == 'new'"
								>送出</el-button
							>
							<el-button
								type="primary"
								@click="saveMainEdit"
								v-if="id !== 'new'"
								>儲存</el-button
							>
							<!-- <el-button type="primary"
                                       @click="submit"
                            v-if="show && id!=='new'">送出</el-button>-->
							<el-button @click="back">取消</el-button>
						</el-tab-pane>
						<el-tab-pane
							label="受益人資料"
							v-if="$route.query.type != 'quit'"
						>
							<workbench
								api="InsEmployeeMemberApplyBnf"
								:query="query"
								:columns="
									columns[recordToEdit.bnfType == 0 ? 0 : 1]
								"
								:toolbar="toolbar"
								@editData="editData"
								@addData="editData"
								@enumData="getBnfEnumData"
								ref="workbench"
							></workbench>
							<el-dialog
								title="受益人設定"
								:visible.sync="dialogListForm"
								:modal-append-to-body="false"
								:append-to-body="true"
							>
								<el-form
									:model="currentEdit"
									ref="ruleForm"
									:rules="rules"
								>
									<el-form-item
										label="順位"
										prop="bnfSeq"
										v-if="recordToEdit.bnfType == 0"
									>
										<el-input
											v-model="currentEdit.bnfSeq"
										></el-input>
									</el-form-item>
									<el-form-item label="姓名" prop="name">
										<el-input
											v-model="currentEdit.name"
										></el-input>
									</el-form-item>
									<el-form-item label="關係" prop="relation">
										<el-select
											v-model="currentEdit.relation"
											placeholder="請選擇關係"
											class="disblock"
										>
											<el-option
												v-for="(
													item, index
												) in bnfDataList"
												:key="index"
												:label="item.label"
												:value="item.value"
											></el-option>
										</el-select>
										<!-- <el-input v-model="currentEdit.relation"></el-input> -->
									</el-form-item>
									<el-form-item label="原因" prop="reason">
										<el-input
											v-model="currentEdit.reason"
										></el-input>
									</el-form-item>
									<strong style="color: red"
										>提醒:如是兄弟姊妹，所有欄位必填</strong
									>
									<el-form-item label="身分證字號">
										<el-input
											v-model="currentEdit.idNumber"
										></el-input>
									</el-form-item>
									<el-form-item label="電話">
										<el-input
											v-model="currentEdit.phone"
										></el-input>
									</el-form-item>
									<el-form-item label="住址">
										<el-input
											v-model="currentEdit.addr"
										></el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogListForm = false"
										>取消</el-button
									>
									<el-button
										type="primary"
										@click="submitForm('ruleForm')"
										>確定</el-button
									>
								</div>
							</el-dialog>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { API } from "@/assets/config";
import Workbench from "@/components/Workbench";

export default {
	name: "employee_coopplusroster_edit",
	components: {
		Workbench,
	},

	data() {
		return {
			value: "",
			options: "",
			submitId: "",
			account: "",
			code: localStorage.getItem("codeValue"),
			apiBnf: "coopInsEmployeeMemberApplyBnf",
			show: false,
			formshow: false,
			underwriteStatusLabel: "核保狀態",
			radio: 0,
			id: this.$route.params.subId,
			type: "",
			api: "",
			subFee: 0,
			subName: "",
			SelectEmployee: "",
			query: {
				insEmployeeMemberApplyId:
					this.$route.params.subId === "new"
						? 0
						: this.$route.params.subId,
			},
			recordToEdit: {
				bnfType: 1,
			},
			toolbar: {},
			addDocStatus: {},
			cardSendStatus: {},
			refoundStatus: {},
			underwriteStatus: [],
			selectProject: [],
			bnfDataList: [],
			yearData: {},
			bnf: [],
			subData: [],
			setTimeKey: [
				"insEffectiveDate",
				"genSendDate",
				"subsidyVoucherDate",
				"employeeEndDate",
				"employeeStartDate",
				"insCardSendDate",
				"addDocDate",
			],
			member: {},
			payment: {},
			columns: [
				[
					{
						label: "順位",
						prop: "bnfSeq",
					},
					{
						label: "身分證字號",
						prop: "idNumber",
					},
					{
						label: "姓名",
						prop: "name",
					},
					{
						label: "關係",
						prop: "relation",
						renderFunction(h, scope, enumData) {
							return h("div", this.$getBnfRelationText(scope.row, enumData.insBnfRelation));
						},
					},
					{
						label: "電話",
						prop: "phone",
					},
					{
						label: "住址",
						prop: "addr",
					},
					{
						prop: "updateTime",
						label: "最後修改",
					},
					{
						prop: "updateUserName",
						label: "最後修改人員",
					},
				],
				[
					{
						label: "身分證字號",
						prop: "idNumber",
					},
					{
						label: "姓名",
						prop: "name",
					},
					{
						label: "關係",
						prop: "relation",
						renderFunction(h, scope, enumData) {
							return h("div", this.$getBnfRelationText(scope.row, enumData.insBnfRelation));
						},
					},
					{
						label: "電話",
						prop: "phone",
					},
					{
						label: "住址",
						prop: "addr",
					},
					{
						prop: "updateTime",
						label: "最後修改",
					},
					{
						prop: "updateUserName",
						label: "最後修改人員",
					},
				],
			],
			dialogListForm: false,
			currentEdit: {
				bnfSeq: "",
				name: "",
				relation: "",
			},
			cadreList: [
				{
					label: "區會幹部",
					value: 4,
				},
				{
					label: "協會幹部",
					value: 5,
				},
				{
					label: "其他",
					value: 3,
				},
			],
			titleList: [
				{
					label: "選擇理監事",
					value: 1,
				},
				{
					label: "聘任幹部",
					value: 2,
				},
				{
					label: "區會幹部",
					value: 4,
				},
				{
					label: "協會幹部",
					value: 5,
				},
				{
					label: "其他",
					value: 4,
				},
			],
			rules: {
				bnfSeq: [
					{ required: true, message: "請輸入順位", trigger: "blur" },
				],
				name: [
					{ required: true, message: "請輸入姓名", trigger: "blur" },
				],
				relation: [
					{
						required: true,
						message: "請選擇受益人關係",
						trigger: "change",
					},
				],
			},
			// 補件通知
			dialogAddDoc: false,
			noticeData: "",
			queryHistory: {
				action: "getNoticeHistoryList",
				sourceId:
					this.$route.params.subId === "new"
						? 0
						: this.$route.params.subId,
				type: this.$route.query.type,
			},
			toolbarHistory: {
				allClose: true,
				search: false,
				select: false,
				editable: false,
			},
			columns2: [
				{
					label: "發送時間",
					prop: "updateTime",
				},
				{
					label: "通知人",
					prop: "updateUserName",
				},
				{
					label: "社業務負責人",
					prop: "ownerUserName",
				},
				{
					label: "已讀/未讀",
					prop: "viewed",
					renderFunction(h, scope, enumData) {
						return h("div", enumData.readKind[scope.row.viewed]);
					},
				},
				{
					prop: "",
					label: "內容",
					renderFunction: (h, scope, enumData) => {
						return h(
							"div",
							{
								style: {
									"text-align": "center",
								},
							},
							[
								h(
									"el-button",
									{
										props: {
											type: "primary",
											plain: true,
										},
										on: {
											click: () => {
												this.showNoticeData(
													scope.row.noticeData
												);
												// this.transferData(scope.row);
											},
										},
									},
									"檢視"
								),
							]
						);
					},
					width: "150",
				},
				{
					label: "email狀態",
					prop: "emailStatus",
					renderFunction(h, scope, enumData) {
						return h(
							"div",
							enumData.scheduleTask[scope.row.emailStatus]
						);
					},
				},
				{
					label: "sms狀態",
					prop: "smsStatus",
					renderFunction(h, scope, enumData) {
						return h(
							"div",
							enumData.scheduleTask[scope.row.smsStatus]
						);
					},
				},
			],
		};
	},
	created() {
		this.getData();
		this.checkType();
	},
	mounted() {
		const vm = this;
		$(".min_go_date").datepicker({
			changeYear: true,
			changeMonth: true,
			currentText: "今天",
			dateFormat: "Rmmdd",
			showButtonPanel: true,
			yearRange: "1912:c+10",
			onSelect(data) {
				let key = $(this)[0].className.split(" ")[2];
				if (data) {
					vm.recordToEdit[key] =
						parseInt(data.split("-")[0]) +
						1911 +
						"-" +
						data.slice(4);
				}
			},
		});
	},
	filters: {
		sexfilter(item) {
			const sex = ["", "男性", "女性"];
			return sex[item];
		},
	},
	watch: {
		$route() {
			this.checkType();
		},
		"recordToEdit.insEmployeeSubId": function () {
			let pos = this.subData.findIndex(
				(sub) => sub.id === this.recordToEdit.insEmployeeSubId
			);
			this.subFee = pos === -1 ? 0 : this.subData[pos].premium;
		},
		"recordToEdit.insEmployeeYearId": {
			handler(newVal) {
				// this.subFee = "";
				// let pos = this.subData.findIndex(
				//     sub => sub.id === this.recordToEdit.insEmployeeSubId
				// );
				// if (
				//     pos != -1 &&
				//     this.subData[pos].insEmployeeYearId !==
				//         this.recordToEdit.insEmployeeYearId
				// ) {
				//     this.recordToEdit.insEmployeeSubId = "";
				// }
				this.selectProject = this.subData.filter((item) => {
					if (item.insEmployeeYearId == newVal) {
						return {
							label: item.name,
							value: item.id,
						};
					}
				});
			},
		},
	},
	methods: {
		//受益人關係選單
		getBnfEnumData(item) {
			this.bnfDataList = Object.keys(item.insBnfRelation).map((items) => {
				return {
					label: item.insBnfRelation[items],
					value: Number(items),
				};
			});
		},
		//受益人欄位驗證
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.saveDialogEdit();
				} else {
					let title = "";
					// this.otherValidate(this.rules);
					// console.log(this.rules);
					this.$message.closeAll();
					this.$message({
						type: "error",
						message: `請輸入必填欄位`,
						duration: 5000,
					});
				}
			});
		},
		otherValidate(rules) {
			Object.keys(this.rules).find((item) => {
				if (!this.currentEdit[item]) {
					if (this.rules[item][0].required) {
						this.$message.closeAll();
						this.$message({
							type: "error",
							message: `${this.rules[item][0].message}`,
							duration: 5000,
						});
						return;
					}
				}
			});
			// Object.keys(this.currentEdit).forEach(item => {
			//     if (!item) {
			//         this.$message.closeAll();
			//         this.$message({
			//             type: "error",
			//             message: "請填寫必填欄位"
			//         });
			//     }
			// });
		},
		getData() {
			const url =
				API.InsEmployeeMemberApply +
				`?id=${
					this.id !== "new" ? this.id : 0
				}&insEmployeeMainCode=${localStorage.getItem("codeValue")}`;
			const thenCB = (json) => {
				this.recordToEdit = Object.assign(
					{},
					this.recordToEdit,
					json.resultData.data
				);

				this.yearData = json.resultData.enumData.insEmployeeYear.map(
					(item) => {
						return {
							label: item.year,
							value: item.id,
						};
					}
				);
				this.subData = json.resultData.enumData.insEmployeeSub.map(
					(item) => {
						return { label: item.code, value: item.id, ...item };
					}
				);
				this.renderAgent(json.resultData.enumData);
				setTimeout(() => {
					this.setTimeKey.forEach((item) => {
						if (json.resultData.data[item]) {
							$(`.${item}`).val(
								`${
									parseInt(json.resultData.data[item]) -
										1911 <
									100
										? `0${
												parseInt(
													json.resultData.data[item]
												) - 1911
										  }${
												json.resultData.data[item]
													.slice(4)
													.split(" ")[0]
										  }`
										: `${
												parseInt(
													json.resultData.data[item]
												) - 1911
										  }${
												json.resultData.data[item]
													.slice(4)
													.split(" ")[0]
										  }` || ""
								}`
							);
						}
					});
				}, 1);
			};
			this.mAxiosGet(url, thenCB);
		},
		renderAgent(enumData) {
			let underwriteStatusSelection = [];
			switch (this.$route.query.type) {
				case "quit":
					this.underwriteStatusLabel = "退保狀態";
					underwriteStatusSelection =
						enumData.insEmployeeUnderwriteStatusBack;
					break;
				case "modify":
					this.underwriteStatusLabel = "資料變更狀態";
					underwriteStatusSelection =
						enumData.insEmployeeUnderwriteStatusModify;
					break;
				default:
					this.underwriteStatusLabel = "核保狀態";
					underwriteStatusSelection =
						enumData.insEmployeeUnderwriteStatusAdd;
					break;
			}

			// 受益人分配方式額外處理
			let arr = [];
			Object.keys(enumData.bnfType).map((key) => {
				arr.push({
					label: enumData.bnfType[key],
					value: parseInt(key),
				});
			});
			this.bnf = arr.reverse();
			this.addDocStatus = this.renderSelection(
				enumData.insEmployeeApplyAddDocStatus
			);
			this.cardSendStatus = this.renderSelection(
				enumData.insEmployeeApplyCardSendStatus
			);
			this.refoundStatus = this.renderSelection(
				enumData.insEmployeeApplyRefoundStatus
			);
			// this.underwriteStatus = this.renderSelection(
			//     enumData.insEmployeeUnderwriteStatus
			// );
			this.underwriteStatus = this.renderSelection(
				underwriteStatusSelection
			);
			this.yearData = enumData.insEmployeeYear.map((item) => {
				item.year = item.year - 1911;
				return item;
			});
			this.subData = enumData.insEmployeeSub;
			this.member = enumData.memberInfo;
		},
		renderSelection(enumSelection) {
			return Object.keys(enumSelection).map((key) => {
				return { label: enumSelection[key], value: parseInt(key) };
			});
		},
		editData(id, row) {
			// edit
			this.currentEdit = {};
			this.dialogListForm = true;
			if (id !== "new") {
				this.currentEdit = Object.assign({}, this.currentEdit, row);
			}
		},
		checkType() {
			if (this.id == "new") {
				// 代辦
				this.type = "add";
			} else {
			}
		},
		append() {
			let url = API.InsEmployeeMemberApply + `?action=append`;
			const form = new FormData();
			if (this.$route.query.type == "quit") {
				form.append("id", this.recordToEdit.id);
				form.append("isMember", this.recordToEdit.isMember || "");
				form.append("account", this.recordToEdit.account || "");
				form.append("name", this.recordToEdit.name || "");
				form.append("idNumber", this.recordToEdit.idNumber || "");
				form.append(
					"insEmployeeSubId",
					this.recordToEdit.insEmployeeSubId || ""
				);
				form.append(
					"insEmployeeYearId",
					this.recordToEdit.insEmployeeYearId || ""
				);
				form.append("sex", this.recordToEdit.sex || "");
				form.append("birthday", this.recordToEdit.birthday || "");
				form.append("title", this.recordToEdit.title || "");

				form.append(
					"memberId",
					this.recordToEdit.isMember == 1
						? this.recordToEdit.memberId
						: 0
				);
				form.append("insEmployeeMainCode", this.code);
				//退保applyType 固定為3
				form.append("applyType", 3);
			} else {
				form.append("id", this.id);
				form.append("bnfType", this.recordToEdit.bnfType || 0);
				form.append("name", this.recordToEdit.name || "");
				form.append("sex", this.recordToEdit.sex || "");
				form.append("insEmployeeMainCode", this.code || "");
				form.append("idNumber", this.recordToEdit.idNumber || "");
				form.append("birthday", this.recordToEdit.birthday || "");
				form.append(
					"employeeEndDate",
					this.recordToEdit.employeeEndDate || ""
				);
				form.append(
					"employeeStartDate",
					this.recordToEdit.employeeStartDate || ""
				);
				form.append("title", this.recordToEdit.jobTitle || "");
				form.append("cadreType", 2);
				form.append(
					"insEmployeeSubId",
					this.recordToEdit.insEmployeeSubId || ""
				);
				form.append(
					"insEmployeeYearId",
					this.recordToEdit.insEmployeeYearId || ""
				);
				// form.append(
				//     "subsidyAmount",
				//     this.recordToEdit.subsidyAmount || ""
				// );
				// form.append(
				//     "subsidyVoucherCode",
				//     this.recordToEdit.subsidyVoucherCode || ""
				// );
				// form.append(
				//     "subsidyVoucherDate",
				//     this.recordToEdit.subsidyVoucherDate || ""
				// );
				form.append(
					"memberId",
					this.recordToEdit.memberId ? this.recordToEdit.memberId : 0
				);
				form.append("cadreType", this.recordToEdit.cadreTitle || "");
				form.append("isMember", this.SelectEmployee == "" ? 0 : 1);
			}

			let thenCB = (json) => {
				this.id = json.resultData.id;
				this.$router.push({
					name: "cadre_coopplusroster_edit",
					params: {
						subId: json.resultData.id,
					},
					query: {
						type: "plus",
					},
				});

				this.showAjaxSuccessMsg();
				this.getData();
			};
			this.mAxiosPost(url, form, thenCB);
		},
		saveMainEdit() {
			let url = API.InsEmployeeMemberApply + `?action=update`;
			const form = new FormData();
			form.append("id", this.id);
			if (this.recordToEdit.insEffectiveDate !== undefined) {
				form.append(
					"insEffectiveDate",
					this.recordToEdit.insEffectiveDate
				);
			}
			if (this.recordToEdit.genSendDate !== undefined) {
				form.append("genSendDate", this.recordToEdit.genSendDate);
			}
			form.append("genSendCode", this.recordToEdit.genSendCode || "");

			form.append(
				"underwriteStatus",
				this.recordToEdit.underwriteStatus || "0"
			);
			form.append(
				"insCardSendStatus",
				this.recordToEdit.insCardSendStatus || "0"
			);
			form.append(
				"refoundStatus",
				this.recordToEdit.refoundStatus || "0"
			);
			form.append(
				"insCardSendDate",
				this.recordToEdit.insCardSendDate || ""
			);

			form.append("needAddDoc", this.recordToEdit.needAddDoc || "");

			if (this.recordToEdit.addDocDate !== undefined) {
				form.append("addDocDate", this.recordToEdit.addDocDate);
			}

			form.append("addDocReason", this.recordToEdit.addDocReason || "");
			form.append(
				"realBackAmount",
				this.recordToEdit.realBackAmount || ""
			);
			form.append("insEmployeeMainCode", this.code);
			form.append(
				"realPremium",
				this.$removeComma(this.recordToEdit.realPremium) || ""
			);
			form.append(
				"insCoopToAssn",
				this.$removeComma(this.recordToEdit.insCoopToAssn) || ""
			);

			let thenCB = (json) => {
				this.showAjaxSuccessMsg();
				this.submitId = json.resultData.id;
				this.show = true;
			};
			this.mAxiosPost(url, form, thenCB);
		},
		submit() {
			let url = API.InsEmployeeMemberApply + `?action=submit`;
			let form = new FormData();
			form.append("id", this.submitId);
			form.append("insEmployeeMainCode", this.code || "");
			let thenCB = (json) => {
				this.showAjaxSuccessMsg();
				// this.getData();
			};
			this.mAxiosPost(url, form, thenCB);
		},
		saveDialogEdit() {
			let url = API[this.apiBnf];
			let form = new FormData();
			if (
				this.currentEdit.id !== "new" &&
				this.currentEdit.id !== 0 &&
				this.currentEdit.id
			) {
				form.append("id", this.currentEdit.id);
				url += `?action=update`;
			} else {
				url += `?action=append`;
			}
			form.append("bnfSeq", this.currentEdit.bnfSeq || 0);
			form.append("idNumber", this.currentEdit.idNumber || "");
			form.append("name", this.currentEdit.name || "");
			form.append("relation", this.currentEdit.relation || "");
			form.append("phone", this.currentEdit.phone || "");
			form.append("addr", this.currentEdit.addr || "");
			form.append("insEmployeeMemberApplyId", this.id);

			// form.append('year', this.currentEdit.year !== undefined ? this.currentEdit.year : '');
			// form.append('periodStart', this.currentEdit.periodStart !== undefined ? this.currentEdit.periodStart : '');
			// form.append('periodEnd', this.currentEdit.periodEnd !== undefined ? this.currentEdit.periodEnd : '');
			// form.append('applicationStart', this.currentEdit.applicationStart !== undefined ? this.currentEdit.applicationStart : '');
			// form.append('applicationEnd', this.currentEdit.applicationEnd !== undefined ? this.currentEdit.applicationEnd : '');

			let thenCB = (json) => {
				this.showAjaxSuccessMsg();

				this.$refs.workbench.getData();
			};
			this.mAxiosPost(url, form, thenCB);
			this.dialogListForm = false;
		},
		getMemberData() {
			let url = API.coopInsEmployeeMemberApply;
			const params = {
				action: "getMemberInfo",
				insEmployeeMainCode: this.code,
				insEmployeeSubId: this.recordToEdit.insEmployeeSubId,
				idNumber: this.currentEdit.idNumber,
			};
			this.$http.get(url, { params }).then((res) => {
				this.currentEdit = res.data.resultData.data;
			});
		},
		schMember() {
			let memberAPi =
				API.coopInsEmployeeMember +
				`?action=getEmployeeByMember&idNumber=${
					this.account
				}&insEmployeeMainCode=${localStorage.getItem("codeValue")}`;
			const thenCB = (json) => {
				// this.member = json.resultData.enumData.member;
				// this.show = true;
				// this.sub = json.resultData.enumData.sub;
				this.payment = json.resultData.enumData.payment;
				this.payment.backAmount =
					json.resultData.enumData.memberBackAmount;

				// this.recordToEdit.memberId = json.resultData.data.memberId;
				// this.recordToEdit.insEmployeeMainCode =
				//     json.resultData.data.insEmployeeMainCode;
				// this.recordToEdit.insEmployeeYearId =
				//     json.resultData.data.insEmployeeYearId;
				// this.recordToEdit.insEmployeeSubId =
				//     json.resultData.data.insEmployeeSubId;
				this.payment = json.resultData.enumData.payment;
				this.recordToEdit = json.resultData.data;
				this.subName = json.resultData.enumData.sub.name;
				this.subFee = json.resultData.enumData.sub.premium;

				this.formshow = true;
			};
			this.mAxiosGet(memberAPi, thenCB);
		},
		valadate() {},
		back() {
			this.$router.push({
				name: "employee_coopplusroster",
				query: {
					type: this.$route.query.type,
				},
			});
		},
		openDialog() {
			this.dialogAddDoc = true;
		},
		sendAddDocNotice() {
			var url = API.InsEmployeeMemberApply;

			if (!this.noticeData) {
				this.$message.error("請輸入補件通知");
				return;
			}

			const form = new FormData();
			if (
				this.query.insEmployeeMemberApplyId !== 0 &&
				this.query.insEmployeeMemberApplyId
			) {
				form.append("sourceId", this.query.insEmployeeMemberApplyId);
				form.append("type", this.$route.query.type);
				url += `?action=createAddDocNotice`;
			}

			form.append("noticeData", this.noticeData);

			let thenCB = (json) => {
				this.showAjaxSuccessMsg();
				this.noticeData = "";
				this.$refs.queryHistory.getData();
			};
			this.mAxiosPost(url, form, thenCB);
		},
		showNoticeData(msg) {
			this.$confirm(msg, "", {
				showClose: false,
				cancelButtonText: "關閉",
				cancelButtonClass: "el-button--danger is-plain",
				showConfirmButton: false,
				center: true,
			});
		},
		resetAmount(amount, key) {
			return (this.recordToEdit[key] = this.$addcomma(
				this.$removeComma(amount)
			));
		},
	},
};
</script>
<style lang="scss">
table.info td {
	padding-top: 0;
	padding-bottom: 0;
}
.disblock {
	display: block;
	position: relative;
	.el-input__suffix {
		top: 30%;
	}
}
</style>